import React,{useLayoutEffect,useRef,useState} from 'react';
export function LinkedMessage({text}){return text.split(/(https?:\/\/[^\s<>]+)/g).map((part,i)=>/^https?:\/\//.test(part)?<a key={i} href={part} target="_blank" rel="noreferrer">{part}</a>:part);}


export function revealMessage(id,focus=true){
 if(!id)return;
 window.dispatchEvent(new CustomEvent('wiki-reveal-message',{detail:id}));
 requestAnimationFrame(()=>requestAnimationFrame(()=>{const el=document.getElementById('message-'+id);if(!el)return;el.scrollIntoView({block:'center'});if(focus){el.tabIndex=-1;el.focus({preventScroll:true});}el.classList.add('message-located');setTimeout(()=>el.classList.remove('message-located'),1800);}));
}
export default function MessageBody({comment,expanded,onExpanded}){
 const ref=useRef(null),[long,setLong]=useState(false);
 useLayoutEffect(()=>{
  const el=ref.current;if(!el)return;
  const measure=()=>setLong(el.scrollHeight>parseFloat(getComputedStyle(el).lineHeight)*10+2);
  measure();const observer=new ResizeObserver(measure);observer.observe(el);return()=>observer.disconnect();
 },[comment.body,Boolean(comment.ai)]);
 function toggle(){
  const article=ref.current.closest('article'),scroller=article.closest('.threads-view'),top=article.getBoundingClientRect().top,viewportTop=scroller.getBoundingClientRect().top;
  onExpanded(comment.id,!expanded);
  if(expanded)requestAnimationFrame(()=>{if(top<viewportTop)scroller.scrollTop+=article.getBoundingClientRect().top-viewportTop-12;article.querySelector('.message-expand')?.focus({preventScroll:true});});
 }
 const foldable=long&&Boolean(comment.ai);
 const control=<button className="message-expand" aria-expanded={Boolean(expanded)} aria-controls={'message-body-'+comment.id} onClick={toggle}>{expanded?'收合':'展開全文'}</button>;
 return <>{foldable&&expanded&&control}<p ref={ref} id={'message-body-'+comment.id} className={'message-body '+(long?'message-body-long ':'')+(comment.ai&&!expanded?'message-body-clamped':'')}><LinkedMessage text={comment.body}/></p>{foldable&&control}</>;
}
